@import '../../../../../../app-brand/entities/entity-layer.module.less';

.date-picker-link-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  text-align: left;
  &:hover {
    color: @fulfillment-planner--ship-date--hover--text-color;
    svg {
      fill: @fulfillment-planner--ship-date--hover--fill-color;
    }
  }
}

.shipment-details-date-read-only-content {
  color: var(--default--text-color--4);
}
